define((require) => {
    "use strict";

    const Class           = require("shared/util/Class");
    const $               = require("jquery");
    const {flatten, map}  = require("underscore");
    const Promise         = require("shared/util/Promise");
    const Preconditions   = require("shared/util/Preconditions");
    const Configuration   = require("shared/services/Configuration");

    // Endpoints
    const KITS      = "kits";
    const FAMILIES  = "families";

    /**
     * Represents the <a href="https://typekit.com/docs/api/" target="_blank">Typekit API</a> - exposing the required endpoints.
     *
     * @class TypekitApi
     * @author Kim
     */
    return Class.extend({

        _apiToken: null,

        constructor(apiToken) {
            this._apiToken = apiToken;
        },

        kits() {
            return this._get(KITS);
        },

        kit(kitID) {
            Preconditions.checkArgument(kitID);

            return this._get(`${KITS}/${kitID}`);
        },

        all() {
            return this.kits()
                .then((response) =>
                    Promise.all(map(response.kits, (kit) => this.kit(kit.id))));
        },

        fonts() {
            return this.all()
                .then((responses) => {
                    const families = map(responses, (response) => response.kit.families);

                    return flatten(families);
                });
        },

        /**
         * Fetches the font family information for the specified font name, i.e. the
         * <tt>slug</tt> name, e.g. <tt>"proxima-nova"</tt> and not <tt>"Proxima Nova"</tt>.
         *
         * @param  {String} slug The <tt>slug</tt> name, e.g. <tt>"proxima-nova"</tt> and not <tt>"Proxima Nova"</tt>.
         * @return {Promise}     A <tt>Promise</tt> that resolves with the font family information.
         */
        family(slug) {
            Preconditions.checkArgument(slug);

            return this._get(`${FAMILIES}/${slug}`);
        },

        _get(path) {
            // TODO: Use backend proxy
            // TODO: Handle error response(s)

            // {
            //     "errors": ["The Typekit API is down for maintenance"]
            // }

            return $.getJSON(`${Configuration.adminApiBaseUrl}/api/typekit/${path}`, {token: this._apiToken})
                .then((response) => response);
        },

        toString() {
            return `TypekitApi[token: ${this._apiToken}]`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/services/fonts/TypekitApi.js